import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'retired-invoice-vats',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <ul>
      <li>Techstreet US Federal ID: 86-1260328</li>
    </ul>

    <ul>
      <li>Techstreet Australian Business Number (ABN): 31 649 479 078</li>
    </ul>
  `,
})
export class RetiredInvoiceVatsComponent {}
